module.exports = __webpack_public_path__ + "images/init/overdue-empty-8db2a6690ea91178092487b61e6321f6.png";